<template>
  <div class="container-component">
    <el-card v-if="type==='card'">
      <slot v-if="$slots.header" name="header" slot="header"/>
        <slot></slot>
    </el-card>
    <card-full v-if="type=== 'card-full' && !drankColor">
        <slot v-if="$slots.header" name="header" slot="header"/>
        <slot></slot>
        <slot v-if="$slots.footer" name="footer" slot="footer"></slot>
    </card-full>
    <card-full v-if="type=== 'card-full' && drankColor" drankColor>
        <slot v-if="$slots.header" name="header" slot="header"/>
        <slot></slot>
        <slot v-if="$slots.footer" name="footer" slot="footer"></slot>
    </card-full>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'card'
    },
    drankColor: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    drankColor (newVal, oldVal) {
      console.log(newVal, oldVal)
    }
  }
}
</script>
<style lang="scss">
.container-component {
  position: absolute;
  top: 40px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
</style>
